import { useAppSelector } from '@/shared/store/hooks';
import { useProfileQuery } from '@/features/profile/api/useProfileQueries';

/** True when the account is allowed to start campaigns on the current day. */
export function useInstantAdAccess(): boolean {
  const sessionFlag = useAppSelector((s) => s.auth.user?.isInstantAdAccess);
  const profile = useProfileQuery({ enabled: !sessionFlag });
  return Boolean(sessionFlag || profile.data?.data?.isInstantAdAccess);
}
